// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content--hide[data-v-9ae86d48]{overflow:hidden}.content--fade[data-v-9ae86d48]{background:linear-gradient(180deg,hsla(0,0%,100%,0),#fff);position:relative}.showmore-less[data-v-9ae86d48]{color:#3c44b1;cursor:pointer}", ""]);
// Exports
module.exports = exports;
